import { createContext, useContext, useState, useMemo } from "react";

export const PreviaIcmsContext = createContext({
  versaoSelecionada: null,
  setVersaoSelecionada: () => {},
  limparVersaoSelecionada: () => {},
  dadosVersao: null,
  setDadosVersao: () => {},
  limparDadosVersao: () => {},
});

export const PreviaIcmsProvider = ({ children }) => {
  const [versaoSelecionada, setVersaoSelecionada] = useState(null);
  const [dadosVersao, setDadosVersao] = useState(null);

  const limparVersaoSelecionada = () => setVersaoSelecionada(null);
  const limparDadosVersao = () => setDadosVersao(null);

  const value = useMemo(
    () => ({
      versaoSelecionada,
      setVersaoSelecionada,
      limparVersaoSelecionada,
      dadosVersao,
      setDadosVersao,
      limparDadosVersao,
    }),
    [versaoSelecionada, dadosVersao]
  );

  return (
    <PreviaIcmsContext.Provider value={value}>
      {children}
    </PreviaIcmsContext.Provider>
  );
};

export const usePreviaIcms = () => useContext(PreviaIcmsContext);
